export default {
  init() {
    // JavaScript to be fired on the about us page
    console.log('arranca el entradas');



    let href = $('.btn-entradas-ciudad').attr('href');


    $('.btnEntradas').attr('href', href);

    $('.popupFamilias').animate({
        'opacity' : '1',
        'height' : '100%',
        'top' : 0,
        'left': 0,
        'width' : '100%',
      }, 1000);

    function cerrarPopUp () {
      $('.popupFamilias').animate({
        'opacity' : '0',
        'height' : '0',
        'top' : '-100vh',
        'left': '-100vw',
        'width' : '0',
      }, 500);
    }

    $('#cerrar').on('click',function(){
      cerrarPopUp ();
    });

    setTimeout(function() {
      var ventana_ancho = $(window).width();
      if (ventana_ancho < 980) {
        cerrarPopUp ();
      }
    }, 5000)




  },
};



// WEBPACK FOOTER //
// ./scripts/routes/template-entradaslanding.js